import { Component, Inject, OnInit } from '@angular/core';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { TableOption } from '../../../components/kiene-table/table-option';
import { DateTableColumn, StatusTableColumn, TableColumn } from '../../../components/kiene-table/table-column';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { ZeitslotBuchung } from '../../../../../projects/kiene-core/src/lib/components/gruppen/schweine/zeitslot-buchen-dialog/zeitslot';

@Component({
    selector: 'kiene-offene-anfragen',
    templateUrl: './landwirt-offene-anfragen.component.html',
    styleUrls: ['./landwirt-offene-anfragen.component.scss'],
})
export class LandwirtOffeneAnfragenComponent implements OnInit {
    tableDescriptor = new TableDescriptor();

    constructor(
        protected _router: Router,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.initOpenTable();
    }

    initOpenTable() {
        this.tableDescriptor.headline = 'Offene Anfragen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'zeitslot_buchung/';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.initialSortColumn = 'buchungs_datum';
        this.tableDescriptor.nameOfIdField = 'zeitslot_buchung_id';
        this.tableDescriptor.route = '/gruppen/zeitslot-historie/';
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.detailsRoute = '/gruppen/landwirt-anfrage-details/';
        this.tableDescriptor.createAllowed = false;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDownloads = true;
        this.tableDescriptor.sendCurrentClient = true;

        this.tableDescriptor.columns = this.getOpenColumns();
        this.tableDescriptor.options = this.getOpenOptions();

        this.tableDescriptor.permissionCreate = 9112;

        let params = new HttpParams();
        params = params.append('storniert', 0);
        this.tableDescriptor.params = params;
    }

    getOpenOptions() {
        const options: TableOption[] = [];
        options.push(new TableOption(this.goToDetails.bind(this), 'Details', 'description', 10008));
        return options;
    }

    getOpenColumns(): TableColumn[] {
        const columns = [];
        columns.push(new TableColumn('date_string', 'Zeitslot'));
        columns.push(new TableColumn('spediteur_bezeichnung', 'Spediteur'));
        columns.push(new TableColumn('schlachthof_bezeichnung', 'Schlachthof'));
        columns.push(new TableColumn('haendler_bezeichnung', 'Händler'));
        columns.push(new TableColumn('tierzahl', 'Tierzahl'));
        columns.push(new DateTableColumn('buchungs_datum', 'Buchungsdatum', 'dd.MM.yy'));
        columns.push(
            new StatusTableColumn(
                'status',
                'Status',
                new Map<number, string>([
                    [233, '#FFAC1C'],
                    [234, '#00ff00'],
                    [235, '#ff0000'],
                    [236, '#FFAC1C'],
                    [237, '#00ff00'],
                    [238, '#ff0000'],
                    [239, '#FFAC1C'],
                    [240, '#00ff00'],
                    [241, '#ff0000'],
                    [242, '#00ff00'],
                    [243, '#00ff00'],
                    [244, '#00ff00'],
                    [245, '#00ff00'],
                ]),
            ),
        );
        return columns;
    }

    goToDetails(zeitslotBuchung: ZeitslotBuchung) {
        this._router.navigate(['/gruppen', 'landwirt-anfrage-details', zeitslotBuchung?.zeitslot_buchung_id]);
    }
}
